import React from 'react';
import { Card, Table } from 'antd';
import type { WorkstationControlCenterQueryParams } from '@/services/workstationControlCenter.service';
import { useWccOperators } from '@/hooks/useWorkstationControlCenter';

interface Props {
  params?: WorkstationControlCenterQueryParams;
}

const OperatorPerformancePanel: React.FC<Props> = ({ params }) => {
  const { data, isLoading } = useWccOperators(params);
  const rows = (data as { rows?: Record<string, unknown>[] })?.rows ?? [];

  return (
    <Card id="operators" title="Operator performance" style={{ marginTop: 16 }}>
      <Table
        size="small"
        loading={isLoading}
        rowKey={(r) => `${r.operator_id}-${r.workstation_id}`}
        dataSource={rows}
        columns={[
          { title: 'Operator', dataIndex: 'operator_id', ellipsis: true },
          { title: 'Workstation', dataIndex: 'workstation_name' },
          { title: 'Hours', dataIndex: 'hours_worked' },
          { title: 'Ops completed', dataIndex: 'operations_completed' },
          { title: 'Efficiency %', dataIndex: 'efficiency' },
        ]}
        pagination={{ pageSize: 15 }}
      />
    </Card>
  );
};

export default OperatorPerformancePanel;
